var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { IG_TAG, Inline, SylController, SylPlugin } from '@syllepsis/adapter';
import { checkMarkDisable, toHex } from '../../utils';
var NAME = 'color';
var getColorAttrs = function (style) {
    var color = toHex(style);
    if (color) {
        return {
            color: color,
        };
    }
    return false;
};
var Color = /** @class */ (function (_super) {
    __extends(Color, _super);
    function Color(editor, props) {
        var _this = _super.call(this, editor, props) || this;
        _this.name = NAME;
        _this.tagName = function () { return 'span'; };
        _this.props = {};
        _this.attrs = {
            color: {
                default: '#000000',
            },
        };
        _this.parseDOM = [
            {
                style: 'color',
                getAttrs: getColorAttrs,
            },
            {
                tag: '*[color]',
                getAttrs: function (dom) { return getColorAttrs(dom.getAttribute('color')); },
            },
        ];
        _this.toDOM = function (node) {
            var _a;
            var color = node.attrs.color;
            var renderColor = color && toHex(color) !== toHex(_this.attrs.color.default) && color;
            return ['span', renderColor ? { style: "color: " + node.attrs.color + ";" } : (_a = {}, _a[IG_TAG] = 'true', _a), 0];
        };
        if (props.default) {
            _this.attrs.color.default = toHex(props.default);
        }
        return _this;
    }
    return Color;
}(Inline));
var ColorController = /** @class */ (function (_super) {
    __extends(ColorController, _super);
    function ColorController(editor, props) {
        var _this = _super.call(this, editor, props) || this;
        _this.name = 'color';
        _this.defaultColor = '#000000';
        _this.getAttrs = function (color) {
            var result = toHex(color);
            if (!result)
                return false;
            return {
                color: result,
            };
        };
        _this.getValue = function (attrs) { return attrs.color; };
        _this.disable = function (editor) { return checkMarkDisable(editor.view, NAME); };
        _this.toolbar = {
            className: 'color',
            tooltip: 'color',
        };
        if (props.default) {
            _this.defaultColor = toHex(props.default);
        }
        return _this;
    }
    return ColorController;
}(SylController));
var ColorPlugin = /** @class */ (function (_super) {
    __extends(ColorPlugin, _super);
    function ColorPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.Controller = ColorController;
        _this.Schema = Color;
        return _this;
    }
    return ColorPlugin;
}(SylPlugin));
export { Color, ColorController, ColorPlugin };
//# sourceMappingURL=index.js.map